import { withMetrics } from "@expert/cloudwatch-metrics";
import { getLogger } from "@expert/logging";
import { Partner } from "@expert/shared-types";
import ky from "ky";
import { env } from "@/config";
import { userCache } from "@/shared-utils";

interface GaiaSpellCheckRequest {
    partner: Partner;
    sessionId: string;
    chatId: string;
    message: string;
}

interface GaiaSpellCheckResponse {
    rewriting_needed: boolean;
    rewritten_text: string;
    highlight_snippets: string[];
}

interface SpellCheckResponse {
    rewritingNeeded: boolean;
    rewrittenText: string;
    highlightSnippets: string[];
}

export const gaiaSpellCheck = async (request: GaiaSpellCheckRequest): Promise<SpellCheckResponse | undefined> => {
    const logger = getLogger({ module: "spellCheck", supportTeam: "messaging" });
    const appName = "expert-assist-messaging-spell-check";
    const userType = "assistant";

    // TODO: If we decide to use this API to do our spell check, convert this into React Query
    const res = await withMetrics(
        "gaiaSpellCheck",
        () =>
            ky
                .post(`${env.gaiaApiUrl}/orchestrator/invoke`, {
                    headers: {
                        "x-app-name": appName,
                        "x-partner-name": request.partner,
                        "x-correlation-id": request.sessionId,
                        Authorization: `Bearer ${userCache.ssoAccessToken}`,
                        "Content-Type": "application/json",
                    },
                    json: {
                        sessionId: request.chatId,
                        sessionGroupId: request.sessionId,
                        userId: userCache.employeeId,
                        messageId: request.sessionId,
                        message: request.message,
                        userType,
                    },
                    timeout: 15000,
                })
                .json<GaiaSpellCheckResponse>(),
        { logger: logger.child(request), rethrow: false, logResult: false },
    );

    if (!res) {
        return;
    }

    return {
        rewritingNeeded: res.rewriting_needed,
        rewrittenText: res.rewritten_text,
        highlightSnippets: res.highlight_snippets,
    };
};
